require('./dysfonctionnement-interface.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';
import { PERMANENT_ALEATOIRE } from '../../../common/model';

export default class DysfonctionnementInterfaceComponent {
  constructor() {
    this.controller = DysfonctionnementInterfaceController;
    this.template = require('./dysfonctionnement-interface.html');
  }
}

// @ngInject
class DysfonctionnementInterfaceController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.PERMANENT_ALEATOIRE = PERMANENT_ALEATOIRE;
    this.data = {
      natureDysfonctionnement: '',
    };
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.DYSFONCTIONNEMENT_INTERFACE));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.dysfonctionnementInterface ? state.demande.data.dysfonctionnementInterface.asMutable({deep: true}) : this.data
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateDysfonctionnementInterface(this.data, true));
  }
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateDysfonctionnementInterface(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/dysfonctionnement-interface/dysfonctionnement-interface.component.js